// extracted by mini-css-extract-plugin
export default {"root":"TransferredOnMobile_root__4AJoN"};